(function () {
    // Test configuration
    const TEST_CONFIG = {
        id: 'SB111DM',
        name: 'Subscription Benefits Pop-Up for OTPs',
        variation: 1,
        selector: 'product-form.product-form .product-form__buttons > div',
        variationClass: '.SB111DM'
    };

    const helpers = {
        waitForElem: function (waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
            const $this = this;
            let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
            if (timer <= 0) return;
            (!isVariable && elements.length >= minElements) ||
                (isVariable && typeof window[waitFor] !== 'undefined') ? callback(elements) : setTimeout(
                    () => $this.waitForElem(waitFor, callback, minElements, isVariable, timer - frequency), frequency
                );
        },

        insertAfter: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML("afterend", html);
        },

        insertBefore: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML("beforebegin", html);
        },

        buildItemsList: function (data = [], html) {
            if (!Array.isArray(data) || typeof html !== "function") return "";
            return data.map((item) => html(item)).join("");
        },

        isMobileScreen: function () {
            return window.innerWidth <= 768;
        },
        debounce: function (func, wait) {
            let timeout;
            let called = false;

            return function (...args) {
                const context = this;

                if (!called) {
                    func.apply(context, args);
                    called = true;
                }

                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    called = false;
                }, wait);
            };
        },
        observeMutations: function (target, callback, options = {}) {
            const {
                config = { childList: true, subtree: true, attributes: false, characterData: false },
                once = false,
            } = options;

            if (!target || typeof callback !== 'function') {
                console.error('observeMutations: Invalid target or callback');
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                callback(mutations, obs);
                if (once) obs.disconnect();
            });

            console.log(config);

            observer.observe(target, config);
            return observer;
        },
        scrollToElement: function (element, offset = 0) {
            if (!element) return;

            const y = element.getBoundingClientRect().top + window.pageYOffset + offset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        },
        injectSwiper: function () {
            var swiperCssLink = document.createElement('link');
            swiperCssLink.rel = 'stylesheet';
            swiperCssLink.type = 'text/css';
            swiperCssLink.href = 'https://unpkg.com/swiper/swiper-bundle.min.css';
            document.head.appendChild(swiperCssLink);

            var swiperJs = document.createElement("script");
            swiperJs.type = "text/javascript";
            swiperJs.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
            document.head.appendChild(swiperJs);
        },
         toTruncatedFixed: function(num, decimals = 2) {
            // Usage examples:

            // console.log(toTruncatedFixed(23.7898));        // "23.78"
            // console.log(toTruncatedFixed(23.7));           // "23.70"
            // console.log(toTruncatedFixed(5.6789, 3));      // "5.678"
            // console.log(toTruncatedFixed(-1.2345, 1));     // "-1.2"
            // console.log(toTruncatedFixed(0.9999, 2));      // "0.99"
            // console.log(toTruncatedFixed(123));            // "123.00"
            let factor = Math.pow(10, decimals);
            let truncated = Math.trunc(num * factor) / factor;
            return truncated.toFixed(decimals);
        }
    };

    const SB111DM = {
        init: function () {
            this.mainCSS();
            this.mainJS();
        },
        mainCSS: function () {
            const s = document.createElement("style");
            s.setAttribute("type", "text/css");
            document.head.appendChild(s).textContent = `
            .OTPsModal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 99;
                display: none;
            }

            .OTPsModal.OTPsModal-open {
                display: block;
            }

            .OTPsModal-overlay {
                display: block !important;
                background: rgba(0, 0, 0, 0.30);
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 1;
            }

            .OTPsModal-content {
                width: 808px;
                position: absolute;
                z-index: 11;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                border-radius: 6px;
                background: #F8F9FB;
                max-width: 100%;
                overflow: hidden;
            }

            .OTPsModal-content .img_area {
                width: 387px;
                height: 489px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .OTPsModal-content .img_area img {
                width: 100%;
                display: block;
            }

            .OTPsModal-content .content_area {
                flex: 1;
                background: #fff;
            }

            product-form.product-form .product-form__buttons{
                position: relative;
            }

            .fakeBtn{
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                z-index: 1;
                display: block;
                cursor: pointer;
            }

            .OTPsModal-content .content_area > h2{
                color: #0A1F2C;
                font-family: 'Aeonik';
                font-size: 32px;
                font-style: normal;
                font-weight: 600;
                line-height: 38px;
                letter-spacing: -0.26px !important;
                margin: 0;
                margin-bottom: 20px;
                margin-top: 20px;
            }

            .OTPsModal-content .content_area > h2 span{
                color: #1B73B3;
            }

            .subHeadArea p{
                color: var(--color-black-solid, #000);
                font-family: 'neue-haas-unica';
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            .OTPsModal-content .list_area{
                margin-bottom: 32px;
            }

            .OTPsModal-content .list_area p {
                color: rgba(10, 31, 44, 0.64);
                font-family: 'neue-haas-unica';
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 21px;
                margin: 0;
            }

            .OTPsModal-content .list_area .list_item {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 10px;
            }

            .subHeadArea {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 20px;
            }
            

            .subHeadArea img {
                width: 87px;
            }

            .OTPsModal-content .content_area {
                padding: 24px 40px;
            }

            .OTPsModal-content .btn_area button.btn_switch {
                display: block;
                width: 100%;
                color: #FFF;
                text-align: center;
                font-family: 'neue-haas-unica';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;
                border-radius: 40px;
                background: #111314;
                padding: 12px 10px;
                margin-bottom: 12px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                overflow: hidden;
            }

            .OTPsModal-content .btn_area button.btn_switch .arrowIcon{
                position: relative;
                top: 3px;
                transform: translate(0);
                transition: all 0.3s ease-in-out;
            }

            .OTPsModal-content .btn_area button.btn_switch:hover .arrowIcon{
                transform: translate(4px);
            }

            .OTPsModal-content .btn_area{
                text-align: center;
            }

            .btn_continue{
                color: #111314;
                text-align: center;
                font-family: 'neue-haas-unica';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-decoration-line: underline;
                background: transparent;
                border: 0;
                cursor: pointer;
            }

            .OTPsModal-content .cross_icon{
                position: absolute;
                right: 17px;
                top: 14px;
                cursor: pointer;
            }

            .OTPsModal-content .list_area .list_item:nth-child(3) p,
            .OTPsModal-content .list_area .list_item:nth-child(4) p{
                font-weight: 400;
            }

            @media (max-width: 768px) {
                .OTPsModal-content .img_area {
                    display: none;
                }

                .OTPsModal-content{
                    max-width: 100%;
                    top: auto;
                    bottom: 0;
                    transform: none;
                    left: 0;
                }

                .OTPsModal-content .content_area > h2{
                    font-size: 28px;
                    margin-bottom: 20px;
                    margin-top: 0;
                }

                .OTPsModal-content .content_area{
                    padding: 24px 20px;
                }

                .OTPsModal-content .subHeadArea{
                    margin-bottom: 15px;
                }

                .OTPsModal-content .list_area{
                    margin-bottom: 24px;
                }
            }
            `;
        },
        mainJS: function () {
            document.body.classList.add(TEST_CONFIG.id);
            // Add any other DOM logic here

            // if(sessionStorage.getItem("skip_subscription_benefits") === "true") return;
            if(document.cookie.includes('OTPsModalShown=true')) return;

            // Resolves which subscription box is currently active/visible on the page.
            // Visibility is determined by the inline `style.display` property, since
            // both the default and custom widgets are present in the DOM simultaneously
            // and only one is shown at a time via inline display toggling.
            function getActiveSubscriptionBox() {
                const defaultBox = document.querySelector('.default-subscription-buybox');
                const customBox = document.querySelector('.custom-subscription-buybox');

                const isDefaultVisible = !!defaultBox && defaultBox.style.display !== 'none';
                const isCustomVisible = !!customBox && customBox.style.display !== 'none';

                console.log('[SB111DM] getActiveSubscriptionBox -> defaultBox:', defaultBox, 'isDefaultVisible:', isDefaultVisible);
                console.log('[SB111DM] getActiveSubscriptionBox -> customBox:', customBox, 'isCustomVisible:', isCustomVisible);

                if (isDefaultVisible) return { box: defaultBox, type: 'default' };
                if (isCustomVisible) return { box: customBox, type: 'custom' };

                console.warn('[SB111DM] getActiveSubscriptionBox -> no visible subscription box found');
                return { box: null, type: null };
            }

            function isOneTimeSelected() {
                const { box, type } = getActiveSubscriptionBox();
                if (!box) {
                    console.warn('[SB111DM] isOneTimeSelected -> no active box, defaulting to false');
                    return false;
                }

                const selectedInput = box.querySelector('input:checked');
                console.log('[SB111DM] isOneTimeSelected -> active box type:', type, 'selectedInput:', selectedInput, 'value:', selectedInput?.value);

                if (!selectedInput) {
                    console.warn('[SB111DM] isOneTimeSelected -> no checked input found in active box, defaulting to false');
                    return false;
                }

                const result = selectedInput.value === 'one-time';
                console.log('[SB111DM] isOneTimeSelected -> result:', result);
                return result;
            }

            function updateProductImage(){
                const currentProductImage = document.querySelector("media-gallery > slider-component > ul > li.is-active img")?.src;
                const imgEl = document.querySelector('.OTPsModal-content .img_area img');
                if (imgEl && currentProductImage) {
                    imgEl.src = currentProductImage;
                } else {
                    console.warn('[SB111DM] updateProductImage -> could not resolve current product image or modal img element');
                }
            }

            function updateSaveAmount(){
                const { box } = getActiveSubscriptionBox();
                // Try the active box first, then fall back to checking both explicitly,
                // since the "save amount" markup pattern may differ between widgets.
                let saveAmount = box?.querySelector('.sub-group-title span.save-amount')?.innerText;

                if (!saveAmount) {
                    saveAmount =
                        document.querySelector('.default-subscription-buybox .sub-group-title span.save-amount')?.innerText ||
                        document.querySelector('.custom-subscription-buybox .sub-group-title span.save-amount')?.innerText ||
                        document.querySelector('.default-subscription-buybox [class*="save"]')?.innerText ||
                        document.querySelector('.custom-subscription-buybox [class*="save"]')?.innerText;
                }

                const saveAmountEl = document.querySelector('.OTPsModal-content .content_area > h2 .saveAmount');
                console.log('[SB111DM] updateSaveAmount -> resolved saveAmount:', saveAmount);

                if (saveAmountEl) {
                    saveAmountEl.innerText = saveAmount || '';
                } else {
                    console.warn('[SB111DM] updateSaveAmount -> could not find .saveAmount element in modal');
                }
            }

            function openOTPsModal() {
                if(document.cookie.includes('OTPsModalShown=true')) return;

                console.log('[SB111DM] openOTPsModal -> opening modal');

                updateProductImage();
                updateSaveAmount();

                const modalEl = document.querySelector('.OTPsModal');
                const fakeBtnEl = document.querySelector('.fakeBtn');

                if (!modalEl) {
                    console.error('[SB111DM] openOTPsModal -> .OTPsModal element not found, cannot open modal');
                    return;
                }

                modalEl.classList.add('OTPsModal-open');
                if (fakeBtnEl) fakeBtnEl.style.display = 'none';
                document.cookie = 'OTPsModalShown=true; path=/';
                console.log('[SB111DM] OTPsModal opened');
            }

            function closeOTPsModal() {
                const modalEl = document.querySelector('.OTPsModal');
                if (modalEl) modalEl.classList.remove('OTPsModal-open');

                const addToCartBtn = document.querySelector('product-form.product-form .product-form__buttons > div button');
                if (addToCartBtn) {
                    addToCartBtn.click();
                } else {
                    console.warn('[SB111DM] closeOTPsModal -> Add to Cart button not found');
                }
            }

            const list = [
                '10% off on every order',
                'Fast & FREE shipping on every delivery',
                'Skip deliveries, swap flavors, or cancel anytime',
                '45-day satisfaction guarantee'
            ]

            const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_120_270)">
                    <mask id="mask0_120_270" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                    <path d="M9.00001 16.5C9.9851 16.5012 10.9607 16.3078 11.8708 15.9308C12.7809 15.5538 13.6076 15.0007 14.3033 14.3033C15.0007 13.6076 15.5538 12.7809 15.9308 11.8708C16.3078 10.9607 16.5012 9.9851 16.5 9.00001C16.5012 8.01491 16.3078 7.03929 15.9308 6.12919C15.5538 5.21909 15.0007 4.39245 14.3033 3.69676C13.6076 2.99932 12.7809 2.44621 11.8708 2.06922C10.9607 1.69223 9.9851 1.49879 9.00001 1.50001C8.01491 1.49879 7.03929 1.69223 6.12919 2.06922C5.21909 2.44621 4.39245 2.99932 3.69676 3.69676C2.99932 4.39245 2.44621 5.21909 2.06922 6.12919C1.69223 7.03929 1.49879 8.01491 1.50001 9.00001C1.49879 9.9851 1.69223 10.9607 2.06922 11.8708C2.44621 12.7809 2.99932 13.6076 3.69676 14.3033C4.39245 15.0007 5.21909 15.5538 6.12919 15.9308C7.03929 16.3078 8.01491 16.5012 9.00001 16.5Z" fill="white" stroke="white" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M6 9L8.25 11.25L12.75 6.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </mask>
                    <g mask="url(#mask0_120_270)">
                    <path d="M0 0H18V18H0V0Z" fill="#039846"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_120_270">
                    <rect width="18" height="18" fill="white"/>
                    </clipPath>
                </defs>
                </svg>`;

            const crossIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 18L18 6M6 6L18 18" stroke="#111314" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

            const arrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
            <g clip-path="url(#clip0_169_7)">
                <path d="M1.56527 12.1304L15.6522 12.1304M9.00005 5.47827L15.6522 12.1304L9.00005 18.7826" stroke="white" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_169_7">
                <rect width="21.913" height="18" fill="white" transform="translate(18) rotate(90)"/>
                </clipPath>
            </defs>
            </svg>`;

            const OTPsModal = `<div class="OTPsModal">
                <div class="OTPsModal-overlay"></div>
                <div class="OTPsModal-content">
                    <div class="cross_icon">
                        ${crossIcon}
                    </div>
                    <div class="img_area">
                        <img src="https://www.transparentlabs.com/cdn/shop/files/01_chocolate.png?v=1778514112&width=1946" />
                    </div>
                    <div class="content_area">
                        <h2>You’re Eligible to Save  <br/> <span><span class="saveAmount"></span> + Free Shipping!</span></h2>
                        <div class="subHeadArea">
                            <img src="https://www.transparentlabs.com/cdn/shop/files/active-subscriber-list.png?v=1753374238&width=260" />
                            <p>Join 100k+ subscribers and unlock:</p>
                        </div>
                        <div class="list_area">
                            ${helpers.buildItemsList(list, (item) => `
                                <div class="list_item">
                                    ${checkIcon}
                                    <p>${item}</p>
                                </div>
                            `)}
                        </div>
                        <div class="btn_area">
                            <button class="btn_switch">Switch to Subscription <span class="arrowIcon">${arrowIcon}</span></button>
                            <button class="btn_continue">Continue without savings</button>
                        </div>
                    </div>
                </div>
            </div>`;

            helpers.insertAfter(document.querySelector('body > *'), OTPsModal);



            const fakeBtn = `<div class="fakeBtn">Add</div>`;

            helpers.insertAfter(document.querySelector('product-form.product-form .product-form__buttons > div'), fakeBtn);

            document.querySelector('.fakeBtn').addEventListener('click', (e) => {
                console.log('[SB111DM] fakeBtn clicked');

                const oneTime = isOneTimeSelected();
                console.log('[SB111DM] fakeBtn click -> isOneTimeSelected() returned:', oneTime);

                if (oneTime) {
                    openOTPsModal();
                } else {
                    const addToCartBtn = document.querySelector('product-form.product-form .product-form__buttons > div button');
                    if (addToCartBtn) {
                        addToCartBtn.click();
                    } else {
                        console.warn('[SB111DM] fakeBtn click -> Add to Cart button not found');
                    }
                }
            });

            document.querySelector('.OTPsModal-overlay').addEventListener('click', (e) => {
                closeOTPsModal();
            });

            document.querySelector('.cross_icon').addEventListener('click', (e) => {
                closeOTPsModal();
            });

            document.querySelector('.btn_continue').addEventListener('click', (e) => {
                closeOTPsModal();
            });

            document.querySelector('.btn_switch').addEventListener('click', (e) => {
                const { box, type } = getActiveSubscriptionBox();

                // Try the standard label pattern first, then fall back to a generic
                // search for a "subscribe"-type radio within whichever box is active,
                // since the custom widget's markup may not match
                // ".subscription-box label" exactly.
                let subscriptionLabel = box?.querySelector('.subscription-box label');

                if (!subscriptionLabel && box) {
                    const subscribeInput = box.querySelector('input[value*="subscri" i], input[value="subscription"]');
                    subscriptionLabel = subscribeInput
                        ? (subscribeInput.closest('label') || document.querySelector(`label[for="${subscribeInput.id}"]`))
                        : null;
                }

                console.log('[SB111DM] btn_switch click -> active box type:', type, 'subscriptionLabel:', subscriptionLabel);

                if (!subscriptionLabel) {
                    console.warn('[SB111DM] btn_switch click -> could not find a subscription label/option to click in the active box');
                }

                subscriptionLabel?.click();
                setTimeout(() => {
                    const addToCartBtn = document.querySelector('product-form.product-form .product-form__buttons > div button');
                    if (addToCartBtn) addToCartBtn.click();
                    closeOTPsModal();
                }, 300);
            });
        },
    };

    // Initialize when the element is available
    helpers.waitForElem(TEST_CONFIG.selector, (elements) => {
        // console.log("Elements found:", elements);
        if (document.querySelector(TEST_CONFIG.variationClass)) return;

        console.log(`${TEST_CONFIG.id} - ${TEST_CONFIG.name} - Variation ${TEST_CONFIG.variation}`);
        SB111DM.init();
    });
})();